import BaseService from '@services/base.service';
import http from '../http-common';
import { customizeError, getResponseData } from '@utils/_function';
class TestimonyService extends BaseService {
    constructor(){
        super('testimonies');
    }

    getExtraitByIdentifiant(identifiantEnterprise) {
        return http.get(`${this.path}/extrait/external/${identifiantEnterprise}`)
            .then((response) => getResponseData(response))
            .catch((err) => Promise.reject(customizeError(err)));
    }

    findAll(identifiantEnterprise) {
        return http.get(`${this.path}/enterprise-testimonies/${identifiantEnterprise}`)
        .then((response) => getResponseData(response))
        .catch((err) => Promise.reject(customizeError(err)));
    }
}

export default new TestimonyService();